<div *ngIf="busy">
  Please wait...
</div>

<div *ngIf="!busy" style="padding-top: 15px;">
  <form [formGroup]="newLadderForm" style="padding-top: 15px;">

    You will be placed in the "waiting room". As soon as we have 9 players/teams, we will start....
    <br /><br />
    <table cellpadding="7">
      <tr>
        <td>Singles/Doubles:</td>
        <td> <select formControlName="ladderId">
            <option value="WAITING_ROOM">Singles</option>
            <option value="WAITING_ROOM_DOUBLES">Doubles</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Level:</td>
        <td><select formControlName="levelId">
            <ng-container *ngFor="let l of levels">
              <option [value]="l.value">{{l.name}}</option>
            </ng-container>
          </select></td>
      </tr>
    </table>
    <br />
    <button (click)="submit()">Sign Me Up!</button>
  </form>
</div>